'use client';
import { vars } from 'nativewind';

export const config = {
  light: vars({
    /* Primary  */
    "--color-primary-0": "232 237 255",
    "--color-primary-50": "184 201 254",
    "--color-primary-100": "154 177 250",
    "--color-primary-200": "132 159 240",
    "--color-primary-300": "106 135 224",
    "--color-primary-400": "71 103 202",
    "--color-primary-500": "49 73 148",
    "--color-primary-600": "34 59 136",
    "--color-primary-700": "24 47 119",
    "--color-primary-800": "17 40 111",
    "--color-primary-900": "11 32 96",
    "--color-primary-950": "6 25 83",

    /* Secondary  */
    "--color-secondary-0": "243 246 255",
    "--color-secondary-50": "235 239 255",
    "--color-secondary-100": "224 231 255",
    "--color-secondary-200": "214 223 255",
    "--color-secondary-300": "204 215 255",
    "--color-secondary-400": "194 207 255",
    "--color-secondary-500": "184 199 255",
    "--color-secondary-600": "173 191 255",
    "--color-secondary-700": "177 194 253",
    "--color-secondary-800": "174 191 252",
    "--color-secondary-900": "170 187 250",
    "--color-secondary-950": "156 176 248",

    /* Tertiary */
    "--color-tertiary-0": "255 236 225",
    "--color-tertiary-50": "254 220 200",
    "--color-tertiary-100": "248 201 173",
    "--color-tertiary-200": "234 176 141",
    "--color-tertiary-300": "218 156 119",
    "--color-tertiary-400": "196 137 102",
    "--color-tertiary-500": "140 103 81",
    "--color-tertiary-600": "132 92 67",
    "--color-tertiary-700": "119 78 52",
    "--color-tertiary-800": "105 63 37",
    "--color-tertiary-900": "86 49 26",
    "--color-tertiary-950": "60 32 14",

    /* Typography */
    "--color-typography-0": "252 252 253",
    "--color-typography-50": "249 250 251",
    "--color-typography-100": "242 244 247",
    "--color-typography-200": "234 236 240",
    "--color-typography-300": "208 213 221",
    "--color-typography-400": "152 162 179",
    "--color-typography-500": "102 112 133",
    "--color-typography-600": "71 84 103",
    "--color-typography-700": "52 64 84",
    "--color-typography-800": "29 41 57",
    "--color-typography-900": "16 24 40",
    "--color-typography-950": "10 19 37",

    /* Background */
    "--color-background-0": "252 252 253",
    "--color-background-50": "249 250 251",
    "--color-background-100": "242 244 247",
    "--color-background-200": "234 236 240",
    "--color-background-300": "208 213 221",
    "--color-background-400": "152 162 179",
    "--color-background-500": "102 112 133",
    "--color-background-600": "71 84 103",
    "--color-background-700": "52 64 84",
    "--color-background-800": "29 41 57",
    "--color-background-900": "16 24 40",
    "--color-background-950": "10 19 37",

    /* Border */
    "--color-border-0": "252 252 253",
    "--color-border-50": "249 250 251",
    "--color-border-100": "242 244 247",
    "--color-border-200": "234 236 240",
    "--color-border-300": "208 213 221",
    "--color-border-400": "152 162 179",
    "--color-border-500": "102 112 133",
    "--color-border-600": "71 84 103",
    "--color-border-700": "52 64 84",
    "--color-border-800": "29 41 57",
    "--color-border-900": "16 24 40",
    "--color-border-950": "10 19 37",

    /* Success */
    "--color-success-0": "228 255 244",
    "--color-success-50": "202 255 232",
    "--color-success-100": "162 241 192",
    "--color-success-200": "132 211 162",
    "--color-success-300": "102 181 132",
    "--color-success-400": "72 151 102",
    "--color-success-500": "52 131 82",
    "--color-success-600": "42 121 72",
    "--color-success-700": "32 111 62",
    "--color-success-800": "22 101 52",
    "--color-success-900": "20 83 45",
    "--color-success-950": "27 50 36",

    /* Error */
    "--color-error-0": "254 233 233",
    "--color-error-50": "254 226 226",
    "--color-error-100": "254 202 202",
    "--color-error-200": "252 165 165",
    "--color-error-300": "248 113 113",
    "--color-error-400": "239 68 68",
    "--color-error-500": "230 53 53",
    "--color-error-600": "220 38 38",
    "--color-error-700": "185 28 28",
    "--color-error-800": "153 27 27",
    "--color-error-900": "127 29 29",
    "--color-error-950": "83 19 19",

    /* Warning */
    "--color-warning-0": "255 249 245",
    "--color-warning-25": "255 245 245",
    "--color-warning-50": "255 244 236",
    "--color-warning-100": "255 231 213",
    "--color-warning-200": "254 205 170",
    "--color-warning-300": "253 173 116",
    "--color-warning-400": "251 149 75",
    "--color-warning-500": "231 120 40",
    "--color-warning-600": "215 108 31",
    "--color-warning-700": "180 90 26",
    "--color-warning-800": "130 68 23",
    "--color-warning-900": "108 56 19",
    "--color-warning-950": "84 45 18",

    /* Info */
    "--color-info-0": "236 248 254",
    "--color-info-25": "240 255 249",
    "--color-info-50": "199 235 252",
    "--color-info-100": "162 221 250",
    "--color-info-200": "124 207 248",
    "--color-info-300": "87 194 246",
    "--color-info-400": "50 180 244",
    "--color-info-500": "13 166 242",
    "--color-info-600": "11 141 205",
    "--color-info-700": "9 115 168",
    "--color-info-800": "7 90 131",
    "--color-info-900": "5 64 93",
    "--color-info-950": "3 38 56",

    /* Outline */
    "--color-outline-0": "253 254 254",
    "--color-outline-50": "243 243 243",
    "--color-outline-100": "230 230 230",
    "--color-outline-200": "221 220 219",
    "--color-outline-300": "211 211 211",
    "--color-outline-400": "165 163 163",
    "--color-outline-500": "140 141 141",
    "--color-outline-600": "115 116 116",
    "--color-outline-700": "83 82 82",
    "--color-outline-800": "65 65 65",
    "--color-outline-900": "39 38 36",
    "--color-outline-950": "26 23 23",

    /* Background Special */
    "--color-background-error": "254 241 241",
    "--color-background-warning": "255 243 234",
    "--color-background-success": "237 252 242",
    "--color-background-muted": "247 248 247",
    "--color-background-info": "235 248 254",

    /* Focus Ring Indicator  */
    "--color-indicator-primary": "55 55 55",
    "--color-indicator-info": "83 153 236",
    "--color-indicator-error": "185 28 28",
  }),
  dark: vars({
    "--color-primary-0": "166 166 166",
    "--color-primary-50": "175 175 175",
    "--color-primary-100": "186 186 186",
    "--color-primary-200": "197 197 197",
    "--color-primary-300": "212 212 212",
    "--color-primary-400": "221 221 221",
    "--color-primary-500": "230 230 230",
    "--color-primary-600": "240 240 240",
    "--color-primary-700": "250 250 250",
    "--color-primary-800": "253 253 253",
    "--color-primary-900": "254 249 249",
    "--color-primary-950": "253 252 252",

    /* Secondary  */
    "--color-secondary-0": "20 20 20",
    "--color-secondary-50": "23 23 23",
    "--color-secondary-100": "31 31 31",
    "--color-secondary-200": "39 39 39",
    "--color-secondary-300": "44 44 44",
    "--color-secondary-400": "56 57 57",
    "--color-secondary-500": "63 64 64",
    "--color-secondary-600": "86 86 86",
    "--color-secondary-700": "110 110 110",
    "--color-secondary-800": "135 135 135",
    "--color-secondary-900": "150 150 150",
    "--color-secondary-950": "164 164 164",

    /* Tertiary */
    "--color-tertiary-0": "84 49 18",
    "--color-tertiary-50": "108 61 19",
    "--color-tertiary-100": "130 73 23",
    "--color-tertiary-200": "180 98 26",
    "--color-tertiary-300": "215 117 31",
    "--color-tertiary-400": "231 129 40",
    "--color-tertiary-500": "251 157 75",
    "--color-tertiary-600": "253 180 116",
    "--color-tertiary-700": "254 209 170",
    "--color-tertiary-800": "255 233 213",
    "--color-tertiary-900": "255 242 229",
    "--color-tertiary-950": "255 250 245",

    /* Error */
    "--color-error-0": "83 19 19",
    "--color-error-50": "127 29 29",
    "--color-error-100": "153 27 27",
    "--color-error-200": "185 28 28",
    "--color-error-300": "220 38 38",
    "--color-error-400": "230 53 53",
    "--color-error-500": "239 68 68",
    "--color-error-600": "249 97 96",
    "--color-error-700": "229 91 90",
    "--color-error-800": "254 202 202",
    "--color-error-900": "254 226 226",
    "--color-error-950": "254 233 233",

    /* Success */
    "--color-success-0": "27 50 36",
    "--color-success-50": "20 83 45",
    "--color-success-100": "22 101 52",
    "--color-success-200": "32 111 62",
    "--color-success-300": "42 121 72",
    "--color-success-400": "52 131 82",
    "--color-success-500": "72 151 102",
    "--color-success-600": "102 181 132",
    "--color-success-700": "132 211 162",
    "--color-success-800": "162 241 192",
    "--color-success-900": "202 255 232",
    "--color-success-950": "228 255 244",

    /* Warning */
    "--color-warning-0": "84 45 18",
    "--color-warning-25": "71, 26, 26",
    "--color-warning-50": "108 56 19",
    "--color-warning-100": "130 68 23",
    "--color-warning-200": "180 90 26",
    "--color-warning-300": "215 108 31",
    "--color-warning-400": "231 120 40",
    "--color-warning-500": "251 149 75",
    "--color-warning-600": "253 173 116",
    "--color-warning-700": "254 205 170",
    "--color-warning-800": "255 231 213",
    "--color-warning-900": "255 244 237",
    "--color-warning-950": "255 249 245",

    /* Info */
    "--color-info-0": "3 38 56",
    "--color-info-25": "13 47 30",
    "--color-info-50": "5 64 93",
    "--color-info-100": "7 90 131",
    "--color-info-200": "9 115 168",
    "--color-info-300": "11 141 205",
    "--color-info-400": "13 166 242",
    "--color-info-500": "50 180 244",
    "--color-info-600": "87 194 246",
    "--color-info-700": "124 207 248",
    "--color-info-800": "162 221 250",
    "--color-info-900": "199 235 252",
    "--color-info-950": "236 248 254",

    /* Typography */
    "--color-typography-0": "23 23 23",
    "--color-typography-50": "38 38 39",
    "--color-typography-100": "64 64 64",
    "--color-typography-200": "82 82 82",
    "--color-typography-300": "115 115 115",
    "--color-typography-400": "140 140 140",
    "--color-typography-500": "163 163 163",
    "--color-typography-600": "212 212 212",
    "--color-typography-700": "219 219 220",
    "--color-typography-800": "229 229 229",
    "--color-typography-900": "245 245 245",
    "--color-typography-950": "254 254 255",

    /* Outline */
    "--color-outline-0": "26 23 23",
    "--color-outline-50": "39 38 36",
    "--color-outline-100": "65 65 65",
    "--color-outline-200": "83 82 82",
    "--color-outline-300": "115 116 116",
    "--color-outline-400": "140 141 141",
    "--color-outline-500": "165 163 163",
    "--color-outline-600": "211 211 211",
    "--color-outline-700": "221 220 219",
    "--color-outline-800": "230 230 230",
    "--color-outline-900": "243 243 243",
    "--color-outline-950": "253 254 254",

    /* Background */
    "--color-background-0": "18 18 18",
    "--color-background-50": "39 38 37",
    "--color-background-100": "65 64 64",
    "--color-background-200": "83 82 82",
    "--color-background-300": "116 116 116",
    "--color-background-400": "142 142 142",
    "--color-background-500": "162 163 163",
    "--color-background-600": "213 212 212",
    "--color-background-700": "229 228 228",
    "--color-background-800": "242 241 241",
    "--color-background-900": "246 246 246",
    "--color-background-950": "255 255 255",

    /* Background Special */
    "--color-background-error": "66 43 43",
    "--color-background-warning": "65 47 35",
    "--color-background-success": "28 43 33",
    "--color-background-muted": "51 51 51",
    "--color-background-info": "26 40 46",

    /* Focus Ring Indicator  */
    "--color-indicator-primary": "247 247 247",
    "--color-indicator-info": "161 199 245",
    "--color-indicator-error": "232 70 69",
  }),
};
